import { PICTREE } from "../../constants";
import {
  combineBudgetSourceRows,
  composeBudgetSummary,
  mergeBudgetSummary,
} from "./budgetHelpers";

const initialHomePhotoShoot = {
  countDenchu: undefined,
  countUniqueUser: undefined,
  countNewUser: undefined,
  countPic: undefined,
  countAsset: undefined,
  countDupeDenchu: undefined,
  countReviewOk: undefined,
  progressDenchu: { taken: 0, max: 0, maxByasset: 0 },
  timings: {}, // {key: ms}
  errors:  {}, // {key: message}
};

const initialHomeCheckInOverview = {
  status: "idle",
  error: null,
  checkinCount: undefined,
  uniqueCheckinAssetCount: undefined,
  uniqueCheckinUserCount: undefined,
  registeredAssetCount: undefined,
  achievementRate: undefined,
};

const initialState = {
  homeDataUser: {},
  homeDataCheckIn: {},
  homeDataCheckInOverview: initialHomeCheckInOverview,
  homeDataPhotoShoot: initialHomePhotoShoot,
  dataPhotoShootByAsset: [],
  checkInByAssetData: {
    status: "idle",
    error: null,
    breakdown: [],
    trend: [],
  },
  dataPhotoShootDetails: [],
  registTrend: [],
  registTable: [],
  usersOverview: [],
  usersList: [],
  userPageNumber: 1,
  salesOverview: [],
  salesTrend: [],
  salesTable: [],
  pointOverview: [],
  pointTrend: [],
  pointTable: [],
  checkInTrend: [],
  dataCheckInMap: [],
  dataCheckInTable: [],
  pictreeView: null,
  photoShootTrend: [],
  photoShootDenchuKaisuTrend: [],
  chartSize: "day",
  mapType: "taken+untaken",
  photoShootMapData: [],
  missionData: [],
  missionSummaryData: {},
  missionRankingData: [],
  rewardCoinSummaryData: {},
  rewardCoinData: [],
  rewardCoinRankingData: [],
  budgetSummary: null,
  budgetBaseSummary: null,
  budgetRemainingTrend: null,
  budgetBySourceRows: [],
  budgetByBoostRows: [],
  budgetBaseSourceRows: [],
  budgetBoostSourceRows: [],
  budgetSourceLoading: false,
  budgetBoostSourceLoading: false,
  budgetBoostLoading: false,
  dateRangePicTree: [null, null],
  periodType: "season",
  dataType: "checkin",
  selectedSeason: [],
  selectedAreaLayerId: "japan_1_l1",
  seasonData: [],
  byAreaDataSummary: [],
  byAreaDataTable: [],
  checkInByAreaData: {
    status: "idle",
    error: null,
    rows: [],
    summary: null,
  },
  missionData: [],
  selectedMission: "blank",
  photoShootTrendByAsset: [],
};

export default function pictreeCommonReducer(state = initialState, action) {
  switch (action.type) {
    case PICTREE.SET_HOME_USER:
      return {
        ...state,
        homeDataUser: action.payload,
      };
    case PICTREE.SET_HOME_CHECKIN_COMMON:
      return {
        ...state,
        homeDataCheckIn: action.payload,
      };
    case PICTREE.GET_HOME_CHECKIN_OVERVIEW_COMMON:
      return {
        ...state,
        homeDataCheckInOverview: {
          ...initialHomeCheckInOverview,
          status: "loading",
        },
      };
    case PICTREE.SET_HOME_CHECKIN_OVERVIEW_COMMON:
      return {
        ...state,
        homeDataCheckInOverview: action.payload,
      };
    case PICTREE.SET_HOME_PHOTOSHOOT_COMMON:
      return {
        ...state,
        homeDataPhotoShoot: action.payload,
      };
    case PICTREE.PATCH_HOME_PICTREE_PHOTO_SHOOT_COMMON:
      return {
        ...state,
        homeDataPhotoShoot: {
          ...state.homeDataPhotoShoot,
          ...action.payload,
          progressDenchu: {
            ...(state.homeDataPhotoShoot.progressDenchu || {}),
            ...(action.payload.progressDenchu || {}),
          },
          timings: {
            ...(state.homeDataPhotoShoot.timings || {}),
            ...(action.payload.timings || {}),
          },
          errors: {
            ...(state.homeDataPhotoShoot.errors || {}),
            ...(action.payload.errors || {}),
          },
        },
      };
    case PICTREE.SET_PHOTOSHOOT_BY_ASSET_COMMON:
      return {
        ...state,
        dataPhotoShootByAsset: action.payload,
      };
    case PICTREE.SET_PHOTOSHOOT_TREND_BY_ASSET_COMMON:
      return {
        ...state,
        photoShootTrendByAsset: action.payload,
      };
    case PICTREE.GET_CHECKIN_BY_ASSET_COMMON:
    case PICTREE.GET_CHECKIN_TREND_BY_ASSET_COMMON:
      return {
        ...state,
        checkInByAssetData: {
          ...state.checkInByAssetData,
          status: "loading",
          error: null,
        },
      };
    case PICTREE.SET_CHECKIN_BY_ASSET_COMMON:
      return {
        ...state,
        checkInByAssetData: {
          ...state.checkInByAssetData,
          status: action.payload?.status || "success",
          error: action.payload?.error || null,
          breakdown: action.payload?.breakdown || [],
        },
      };
    case PICTREE.SET_CHECKIN_TREND_BY_ASSET_COMMON:
      return {
        ...state,
        checkInByAssetData: {
          ...state.checkInByAssetData,
          status: action.payload?.status || "success",
          error: action.payload?.error || null,
          trend: action.payload?.trend || [],
        },
      };
    case PICTREE.SET_PHOTOSHOOT_DETAILS:
      return {
        ...state,
        dataPhotoShootDetails: action.payload,
      };
    case PICTREE.SET_REGIST_TREND:
      return {
        ...state,
        registTrend: action.payload,
      };
    case PICTREE.SET_REGIST_TABLE:
      return {
        ...state,
        registTable: action.payload,
      };
    case PICTREE.SET_SALES_OVERVIEW:
      return {
        ...state,
        salesOverview: action.payload,
      };
    case PICTREE.SET_SALES_TREND:
      return {
        ...state,
        salesTrend: action.payload,
      };
    case PICTREE.SET_SALES_TABLE:
      return {
        ...state,
        salesTable: action.payload,
      };
    case PICTREE.SET_POINT_OVERVIEW:
      return {
        ...state,
        pointOverview: action.payload,
      };
    case PICTREE.SET_POINT_TREND:
      return {
        ...state,
        pointTrend: action.payload,
      };
    case PICTREE.SET_POINT_TABLE:
      return {
        ...state,
        pointTable: action.payload,
      };
    case PICTREE.SET_CHECKIN_TREND_COMMON:
      return {
        ...state,
        checkInTrend: action.payload,
      };
    case PICTREE.SET_CHECKIN_MAP:
      return {
        ...state,
        dataCheckInMap: action.payload,
      };
    case PICTREE.SET_CHECKIN_TABLE:
      return {
        ...state,
        dataCheckInTable: action.payload,
      };
    case PICTREE.SET_PICTREE_VIEW:
      return {
        ...state,
        pictreeView: action.payload,
      };
    case PICTREE.SET_PHOTOSHOOT_TREND_COMMON:
      return {
        ...state,
        photoShootTrend: action.payload,
      };
    case PICTREE.SET_PHOTOSHOOT_DENCHU_KAISU_TREND:
      return {
        ...state,
        photoShootDenchuKaisuTrend: action.payload,
      };
    case PICTREE.SET_USER_LIST:
      return {
        ...state,
        usersList: action.payload,
      };
    case PICTREE.SET_PICTREE_USER_PAGE_NUMBER:
      return {
        ...state,
        userPageNumber: action.payload,
      };
    case PICTREE.SET_CHART_SIZE:
      return {
        ...state,
        chartSize: action.payload,
      };
    case PICTREE.SET_MAP_TYPE:
      return {
        ...state,
        mapType: action.payload,
      };
    case PICTREE.SET_PHOTOSHOOT_MAP_DATA_COMMON:
      return {
        ...state,
        photoShootMapData: action.payload,
      };
    case PICTREE.SET_MISSION_DATA:
      return {
          ...state,
          missionData: action.payload
      };
    case PICTREE.SET_MISSION_SUMMARY_DATA:
      return {
          ...state,
          missionSummaryData: action.payload
      };
    case PICTREE.SET_MISSION_RANKING_DATA:
      return {
          ...state,
          missionRankingData: action.payload
      };
    case PICTREE.SET_REWARD_COIN_SUMMARY_DATA:
      return {
          ...state,
          rewardCoinSummaryData: action.payload
      };
    case PICTREE.SET_REWARD_COIN_DATA:
      return {
          ...state,
          rewardCoinData: action.payload
      };
    case PICTREE.SET_REWARD_COIN_RANKING_DATA:
      return {
          ...state,
          rewardCoinRankingData: action.payload
      };
    case PICTREE.SET_BUDGET_SUMMARY_DATA_COMMON: {
      const baseSourceRowsCommon = action.payload?.bySourceRows || [];
      const baseSummaryCommon = action.payload ? mergeBudgetSummary(null, action.payload) : null;
      return {
        ...state,
        budgetBaseSummary: baseSummaryCommon,
        budgetSummary: composeBudgetSummary(baseSummaryCommon, state.budgetBoostSourceRows, state.budgetSummary?.boostEventCount),
        budgetBaseSourceRows: baseSourceRowsCommon,
        budgetBySourceRows: combineBudgetSourceRows(baseSourceRowsCommon, state.budgetBoostSourceRows),
      };
    }
    case PICTREE.SET_BUDGET_REMAIN_TREND_DATA_COMMON:
      return {
        ...state,
        budgetRemainingTrend: action.payload || null,
      };
    case PICTREE.SET_BUDGET_BOOST_DATA_COMMON:
      return {
        ...state,
        budgetByBoostRows: action.payload || [],
      };
    case PICTREE.SET_BUDGET_BOOST_SOURCE_DATA_COMMON: {
      const boostSourceRowsCommon = action.payload?.rows || [];
      const boostEventCount = action.payload?.boostEventCount;
      return {
        ...state,
        budgetBoostSourceRows: boostSourceRowsCommon,
        budgetSummary: composeBudgetSummary(state.budgetBaseSummary, boostSourceRowsCommon, boostEventCount),
        budgetBySourceRows: combineBudgetSourceRows(state.budgetBaseSourceRows, boostSourceRowsCommon),
      };
    }
    case PICTREE.SET_BUDGET_SOURCE_LOADING_COMMON:
      return {
        ...state,
        budgetSourceLoading: Boolean(action.payload),
      };
    case PICTREE.SET_BUDGET_BOOST_SOURCE_LOADING_COMMON:
      return {
        ...state,
        budgetBoostSourceLoading: Boolean(action.payload),
      };
    case PICTREE.SET_BUDGET_BOOST_LOADING_COMMON:
      return {
        ...state,
        budgetBoostLoading: Boolean(action.payload),
      };
    case PICTREE.SET_PERIOD_TYPE:
      return {
        ...state,
          periodType: action.payload
      };
    case PICTREE.SET_SELECTED_SEASON_COMMON:
      return {
          ...state,
          selectedSeason: action.payload || []
      };
    case PICTREE.SET_DATA_TYPE_COMMON:
      if (action.payload === state.dataType) {
        return state;
      }
      return {
        ...state,
        dataType: action.payload === "report" ? "report" : "checkin",
        homeDataCheckIn: {},
        homeDataCheckInOverview: initialHomeCheckInOverview,
        checkInTrend: [],
        dataCheckInTable: [],
        homeDataPhotoShoot: initialHomePhotoShoot,
        dataPhotoShootByAsset: [],
        photoShootTrend: [],
        photoShootTrendByAsset: [],
        checkInByAssetData: { status: "idle", error: null, breakdown: [], trend: [] },
        byAreaDataSummary: [],
        byAreaDataTable: [],
        checkInByAreaData: { status: "idle", error: null, rows: [], summary: null },
      };
    case PICTREE.SET_SELECTED_AREA_LAYER_COMMON:
      return {
          ...state,
          selectedAreaLayerId: action.payload || "japan_1_l1"
      };
    case PICTREE.SET_SEASON_DATA_COMMON:
      return {
          ...state,
          seasonData: action.payload
      };
    case PICTREE.SET_BY_AREA_DATA_SUMMARY_COMMON:
      return {
        ...state,
        byAreaDataSummary: action.payload
      };
    case PICTREE.SET_BY_AREA_DATA_TABLE_COMMON:
      return {
        ...state,
        byAreaDataTable: action.payload
      };
    case PICTREE.SET_BY_AREA_DATA_COMMON:
      return {
        ...state,
        byAreaDataSummary: action.payload?.summary || null,
        byAreaDataTable: action.payload?.table || [],
      };
    case PICTREE.GET_BY_AREA_CHECKIN_DATA_COMMON:
      return {
        ...state,
        checkInByAreaData: {
          status: "loading",
          error: null,
          rows: [],
          summary: null,
        },
      };
    case PICTREE.SET_BY_AREA_CHECKIN_DATA_COMMON:
      return {
        ...state,
        checkInByAreaData: {
          status: action.payload?.status || "success",
          error: action.payload?.error || null,
          rows: action.payload?.rows || [],
          summary: action.payload?.summary || null,
        },
      };
    default:
      return state;
  }
}
